<app-page-container>
  <app-header class="c-header" appTitle="Equipamentos" divider>
    <p class="is-title">Abrir novo chamado</p>
    <app-botao-voltar class="c-header__button"></app-botao-voltar>
  </app-header>
  <div class="c-router-outlet-container">
    <router-outlet></router-outlet>
  </div>
</app-page-container>